<form [formGroup]="customerForm" class="layout-form" (ngSubmit)="onSubmit()">
  <div class="component-content">
    <div class="form-header">
      <p>Novo cliente</p>
      <span>Insira o endereço da sua empresa</span>
    </div>
    <div class="scroll-display" (scroll)="onScroll($event)">
      <div class="customer-input-container">
        <app-text-input
          [attr.data-testid]="'nombre-fantansia'"
          [labelText]="'Nome da sua empresa'"
          [type]="'text'"
          [required]="true"
          formControlName="fantasyName"
          [submitted]="submitted"
        ></app-text-input>
      </div>
      <div [ngClass]="{ 'form-map': true, 'warning-label': submitted && !customerForm.get('location')?.valid }">
        <app-map formControlName="location" [required]="true" [submitted]="submitted"></app-map>
      </div>
    </div>
  </div>
  <div class="form-navigation">
    <app-navigation [currentStep]="1" [countSteppers]="5"></app-navigation>
  </div>
  <div class="button-container">
    <button mat-raised-button class="next-button" type="submit">Seguindo</button>
  </div>
</form>
